import { EuiLoadingSpinner } from "@elastic/eui";

const Loader = () => {
  return <EuiLoadingSpinner />;
};

export default Loader;
